import React, {memo, FC} from "react";
import {Currency, GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../../generated/graphql";
import css from "./BookingDetails.less";
import SummarySection from "../../../../views/SummarySection/SummarySection";
import i18n from "../../../../services/i18n";
import {useCurrency} from "../../../../helpers/currencyHelper";
import {renderAmount} from "../../../../helpers/renderAmount";

type BookerSectionProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
};

const BookerSection: FC<BookerSectionProps> = ({booking}) => {
    const booker = booking?.attendee?.booker;

    if (!booker) {
        return null;
    }

    const {
        firstname,
        lastname,
        email,
        phoneNumber,
        street,
        houseNumber,
        postCode,
        city,
        customerNumber,
        customerNumberPrefix,
        credit: bookerCredit,
    } = booker;
    const prefixedCustomerNumber = customerNumberPrefix ? `${customerNumberPrefix}${customerNumber}` : customerNumber;

    const handleStreetAndHouseNumber = (street?: string, houseNumber?: string) => {
        const hourseNumberInStreet = /([A-Za-z])+.+\d/.test(street ?? "");

        if (hourseNumberInStreet) {
            return street;
        }

        return `${street} ${houseNumber}`;
    };

    return (
        <SummarySection
            className={css.section}
            title="KursBucherin"
            content={
                <div className={css.bookingDetails}>
                    <div className={css.extraBig}>
                        <span className={css.primary}>{firstname}</span>
                        <span className={css.secondary}>{lastname}</span>
                        <span className={css.secondary}>{`(${prefixedCustomerNumber})`}</span>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{"Telefon"}</div>
                        <div className={css.entry}>{phoneNumber}</div>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{i18n.containers.bookings.BookingSummary.address()}</div>
                        <div className={css.entry}>{handleStreetAndHouseNumber(street, houseNumber)}</div>
                        <div className={css.entry}>{postCode + " " + city}</div>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{i18n.containers.bookings.BookingSummary.bookerCredit()}</div>
                        <div className={css.entry}>
                            <BookerCredit bookerCredit={bookerCredit} />
                        </div>
                    </div>
                    <div className={css.standardContainer} style={{gridColumn: "span 6"}}>
                        <div className={css.label}>{"E-Mail"}</div>
                        <div className={css.entry}>{email}</div>
                    </div>
                </div>
            }
        />
    );
};

export default memo(BookerSection);

const BookerCredit = ({bookerCredit}: {bookerCredit?: number | null}) => {
    const currency = useCurrency();

    return (
        <>
            {bookerCredit && bookerCredit > 0 ? (
                <div>
                    {renderAmount({
                        amount: bookerCredit,
                        currency: currency.short as Currency,
                    })}
                </div>
            ) : (
                <div>{"Dieser Bucher hat kein Guthaben"}</div>
            )}
        </>
    );
};
